<template>
    <div class="column is-offset-1 is-10">
        <template v-if="fetchingContributor || fetchingContributions">
            <div class="content-loader">
                <ContentLoader
                    :height="72"
                    :width="1076"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    class="mb-3"
                >
                    <rect x="16" y="0" rx="0" ry="0" width="200" height="72"/>
                </ContentLoader>
                <ContentLoader
                    :height="640"
                    :width="1076"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                    class="mb-2"
                >
                    <rect x="16" y="0" rx="0" ry="0" width="1060" height="200"/>
                    <rect x="16" y="220" rx="0" ry="0" width="1060" height="180"/>
                    <rect x="16" y="420" rx="0" ry="0" width="1060" height="200"/>
                </ContentLoader>
            </div>
        </template>
        <template v-else>
            <div class="d-flex mb-5" v-if="contributor">
                <template v-if="contributor.name">
                    <div class="avatar mr-3 d-none d-sm-block"><span class="avatar__initials">{{contributor.initials}}</span></div>
                    <div class="">
                        <h1>{{contributor.name}}</h1>
                        <h5 class="t-dark-grey" v-if="contributions">{{contributions.total}} Contributions</h5>
                    </div>
                </template>
                <template v-else>
                    <h1>Contributor doesn't exist</h1>
                </template>
            </div>
            <div class="card p-2 p-lg-7 mb-3" v-for="contribution in contributions.data">
                <div class="d-block d-sm-flex justify-content-between align-items-center mb-3">
                    <div class="card__hazard-meta mb-2 mb-sm-0">
                        <h2 class="t-orange">{{contribution.hazard.name}}</h2>
                        <h5 class="t-navy">{{contribution.hazard.type.name}}</h5>
                    </div>
                    <a :href="contribution.hazard.url" class="btn">Visit UXO</a>
                </div>
                <div class="contribution__meta fs-12 font-weight-light t-navy lh-sm mb-2">Contributed on
                    {{formattedDate(contribution.created_at)}}
                </div>
                <div class="contribution__content font-weight-light lh-lg">
                    {{contribution.contribution_text}}
                </div>
                <div v-if="getLinks(contribution.contribution_text)" class="social-card-wrapper mt-6">
                    <div class="social-card-container"
                         :key="index"
                         v-for="(link, index) in getLinks(contribution.contribution_text)">
                        <link-prevue :apiUrl="$root.linkPrevueApiUrl" :url="link.href">
                            <template slot-scope="props">
                                <a v-if="props.img || props.title || props.description"
                                   target="_blank"
                                   v-bind:href="props.url">
                                    <div class="social-card">
                                        <div v-if="props.img" class="social-card__image"
                                             :style="`background-image: url('${props.img}')`">

                                        </div>
                                        <div class="social-card__content">
                                            <h4 v-if="props.title" class="social-card__content-title">
                                                {{ props.title }}</h4>
                                            <p v-if="props.description" class="social-card__content-body">
                                                {{ props.description }}</p>
                                        </div>
                                    </div>
                                </a>
                                <div v-else></div>
                            </template>
                        </link-prevue>
                    </div>
                </div>

                <cat-uxo-thumbnail-gallery class="d-flex mt-3" v-if="contribution.files.length"
                                           :files="contribution.files"></cat-uxo-thumbnail-gallery>
                <cat-uxo-file-list class="rows mt-3" v-if="contribution.files.length"
                                   :files="contribution.files"></cat-uxo-file-list>
            </div>
        </template>
        <template v-if="contributions.last_page > 1">
            <paginate
                :page-count="contributions.last_page"
                :prev-text="'&nbsp;'"
                :next-text="'&nbsp;'"
                :prev-link-class="'pagination-previous'"
                :next-link-class="'pagination-next'"
                :container-class="'pagination-list'"
                :page-class="'pagination-item'"
                :page-link-class="'pagination-link'"
                :click-handler="paginate">
            </paginate>
        </template>
    </div>
</template>

<script>
    import {ContentLoader} from 'vue-content-loader';
    import CatUxoFileList from '@/js/components/shared/FileList';
    import CatUxoThumbnailGallery from '@/js/components/shared/ThumbnailGallery';
    import moment from "moment";
    import {mapActions, mapState} from "vuex";
    import * as linkify from "linkifyjs";
    import LinkPrevue from "@/js/components/shared/LinkPrevue";

    export default {
        name: "CatUxoPageSupporter",
        components: {
            ContentLoader,
            CatUxoThumbnailGallery,
            CatUxoFileList,
            LinkPrevue
        },
        props: {
            user: {
                type: Object
            },
            contributorId: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {}
        },
        methods: {
            ...mapActions('contributor', [
                'fetchContributor',
            ]),
            ...mapActions('contribution', [
                'fetchContributorContributions',
            ]),
            formattedDate(date) {
                return moment(date, 'YYYY-MM-DD HH:mm:ss').format('Do MMMM YYYY @ HH:mm');
            },
            paginate: function (page) {
                this.fetchContributorContributions({contributorId: this.contributorId, page: page});
            },
            getLinks(content) {
                return linkify.find(content).filter(link => {
                    return link.type === 'url'
                })
            }
        },
        computed: {
            ...mapState('contributor', [
                'fetchingContributor',
                'contributor',
            ]),
            ...mapState('contribution', [
                'fetchingContributions',
                'contributions',
            ]),
        },
        created() {
            this.fetchContributor({contributorId: this.contributorId}).then(() => {
                this.fetchContributorContributions({contributorId: this.contributorId, page: 1});
            });
        },
        mounted() {
        }
    }
</script>


<style lang="scss" scoped>

    .contribution__content {
        white-space: pre-line;
    }

    @include media-breakpoint-down(xs) {
        h2 {
            font-size: rem(24px);
        }

        .btn {
            width: 100%;
        }

        .contributor {
            flex-wrap: wrap;

            .column {
                flex-basis: auto;
            }

            &__name,
            &__total {
                width: 100%;
            }

            &__total {
                margin-bottom: rem(12px);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/pages/Supporter.vue